export const CHECKBOX_CELL_CATEGORIES = ["CHECKBOX", "FLAG", "STAR"];
//# sourceMappingURL=CellValueType.js.map